// Tidy a person's name for display/storage without destroying intentional
// capitalization.
//
// The previous implementation uppercased the first CHARACTER of each
// whitespace/hyphen token and force-lowercased the rest. That silently
// reverted any capital letter that wasn't in the leading position:
//   "Haddock (Dionne)" -> "Haddock (dionne)"   (maiden name in parens)
//   "McDonald" -> "Mcdonald", "O'Brien" -> "O'brien", "DeAngelo" -> "Deangelo"
// So an editor trying to capitalize such a name could never make it "stick"
// — the browser rewrote their change before it was ever sent.
//
// Rule now: capitalize the first LETTER of each token (wherever it sits —
// e.g. after a "("), and only normalize the rest of a token when it is
// uniform case (all-lower or all-upper, as legacy ALL-CAPS imports are).
// A token that already carries an intentional internal capital is preserved.
export const toTitleCase = (s = '') => s
  .split(/\s+/)
  .map((word) => word
    .split('-')
    .map((seg) => {
      if (!seg) return '';
      const letters = seg.replace(/[^A-Za-z]/g, '');
      const uniformCase = letters === letters.toLowerCase() || letters === letters.toUpperCase();
      const base = uniformCase ? seg.toLowerCase() : seg;
      // Uppercase the first alphabetic character, leave everything else as-is.
      return base.replace(/[A-Za-z]/, (c) => c.toUpperCase());
    })
    .join('-'))
  .join(' ')
  .trim();

export default toTitleCase;
